import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Raphael from 'raphael/raphael'
import LoadScript from 'vue-plugin-load-script';
import router from '@/router';
import store from '@/store';
import { sync } from 'vuex-router-sync'

sync(store, router)
global.Raphael = Raphael;
Vue.use(LoadScript);
Vue.use(Vuetify);

//import FlagIcon from 'vue-flag-icon'
//Vue.use(FlagIcon);

Vue.config.productionTip = false
export default new Vuetify({ })

new Vue({
  render: h => h(App),
  vuetify: new Vuetify(),  
  router,
  store
}).$mount('#app')
